import { render, staticRenderFns } from "./RPResponsePill.vue?vue&type=template&id=97780704&"
import script from "./RPResponsePill.vue?vue&type=script&lang=js&"
export * from "./RPResponsePill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RPResponsePill.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports